<template>
  <div>
    <div class="common-title" id="WELFARE">
      <div class="common-title-content">
        福利待遇
      </div>
    </div>
    <div class="grid">
      <div class="row" v-for="(content, index) in contents" :key="index">
        <div class="col" v-for="(col, ix) in content" :key="ix">
          <div class="top">
            <p>{{ col.title }}</p>
            <ul>
              <li v-for="(item, idx) in col.list" :key="idx">
                {{ item }}
              </li>
            </ul>
          </div>
          <div class="bot">
            <img :src="col.imgSrc" />
          </div>
        </div>
        <div class="col" v-if="index == contents.length - 1"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "welfare",
  data() {
    return {
      contents: [
        [
          {
            title: "幸福办公",
            list: [
              "当代梦工场，年轻人的造梦坊",
              "园区美，配套全，吃喝玩乐+健身，一样都不少",
              "清新优雅、星级服务、食堂美味难忘怀"
            ],
            imgSrc: require("@/assets/images/joinUs/img01.png")
          },
          {
            title: "便捷出行",
            list: [
              "地铁2号线；有轨电车",
              "二环、三环、东湖隧道",
              "武汉三镇都便利"
            ],
            imgSrc: require("@/assets/images/joinUs/img02.png")
          },
          {
            title: "实力补贴",
            list: ["餐费补贴", "交通补贴", "通信补贴"],
            imgSrc: require("@/assets/images/joinUs/img03.png")
          }
        ],
        [
          {
            title: "健康福利",
            list: [
              "五险一金入职即有",
              "免费体检年年组织",
              "“基础+补充“省心就医,意外无忧"
            ],
            imgSrc: require("@/assets/images/joinUs/img04.png")
          },
          {
            title: "温馨团队",
            list: [
              "年轻有活力，沟通无障碍",
              "暖心福利，惊喜不断",
              "花式团建，快乐工作",
              "你中有我，我中有你，全景温暖如一家"
            ],
            imgSrc: require("@/assets/images/joinUs/img05.png")
          },
          {
            title: "全景特色",
            list: [
              "弹性考勤制，睡到自然醒",
              "累计调休不设限，亲子时光不用愁",
              "社团活动，精彩纷呈，工作生活两不误",
              "年假年年有，旅行说走就走"
            ],
            imgSrc: require("@/assets/images/joinUs/img06.png")
          }
        ],
        [
          {
            title: "发展无限",
            list: [
              "发力智慧城市，稳抓时代浪潮",
              "小梦想，大舞台，你的未来你做主",
              "大牛学霸在身边，每天都有新收获"
            ],
            imgSrc: require("@/assets/images/joinUs/img07.png")
          },
          {
            title: "互相成就",
            list: [
              "培训学习月月有，职场晋升有通道",
              "考试、认证有补贴，软著、专利高奖金",
              "技术应用属前沿，行业赛道无极限"
            ],
            imgSrc: require("@/assets/images/joinUs/img08.png")
          }
        ]
      ]
    };
  }
};
</script>

<style lang="less" scoped>
.common-title-content {
  background-color: #f2f3f5;
}
.grid {
  padding: 0 11rem 6rem;
  background-color: #f2f3f5;
  overflow: hidden;
  .row {
    margin-bottom: 2.1rem;
    display: flex;
    justify-content: space-between;
    &:last-child {
      margin-bottom: 0 !important;
    }
    .col {
      width: 23.9rem;
      margin: 0 0.3rem;
      .top {
        height: 13rem;
        padding: 1.8rem 0 0 1.6rem;
        background-color: #ffffff;
        p {
          font-size: 1.4rem;
          font-weight: bold;
          color: #2a2e2e;
        }
        ul {
          margin-top: 1rem;
          font-size: 0.7rem;
          color: #5f6464;
          line-height: 1.4rem;
        }
      }
      .bot {
        position: relative;
        width: 100%;
        height: 9rem;
        &::before {
          content: "";
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          background-color: rgba(208, 226, 255, 0.2);
        }
        img {
          width: 100%;
          height: 100%;
        }
      }
      &:hover {
        .top {
          background-image: url("~@/assets/images/joinUs/hover.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          p {
            color: #ffffff;
          }
          ul {
            color: #ffffff;
          }
        }
      }
      &:last-child {
        background-color: #2f61ae;
      }
    }
  }
}
</style>
